import { API_BASE_URL } from "../../constants/index";
import { buildUrl } from "../../utilities/index";
import HttpInterface from "../../helpers/HttpInterface";

export class OrdersService {
  constructor() {
    this.httpProxy = new HttpInterface();
  }

  all(params = {}) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      buildUrl(`${API_BASE_URL}/logistic-service/orders`, params),
      requestOptions
    );
  }

  get(id) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/orders/${id}`,
      requestOptions
    );
  }

  create(order) {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(order),
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/orders`,
      requestOptions
    );
  }

  edit(order) {
    const requestOptions = {
      method: "PUT",
      body: JSON.stringify(order),
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/orders/${order.id}`,
      requestOptions
    );
  }

  delete(id) {
    const requestOptions = {
      method: "DELETE",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/orders/${id}`,
      requestOptions
    );
  }

  confirm(id) {
    const requestOptions = {
      method: "POST",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/orders/${id}/status/CONFIRMED`,
      requestOptions
    );
  }

  draft(id) {
    const requestOptions = {
      method: "POST",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/orders/${id}/status/DRAFT`,
      requestOptions
    );
  }

  cancel(id) {
    const requestOptions = {
      method: "POST",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/orders/${id}/status/CANCELLED`,
      requestOptions
    );
  }

  receive(id) {
    const requestOptions = {
      method: "POST",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/orders/${id}/status/RECEIVED`,
      requestOptions
    );
  }

  process(id) {
    const requestOptions = {
      method: "POST",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/orders/${id}/status/PROCESSING`,
      requestOptions
    );
  }

  returnDelivered(id) {
    const requestOptions = {
      method: "POST",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/orders/${id}/status/RET_DELIVERED`,
      requestOptions
    );
  }

  ship(id) {
    const requestOptions = {
      method: "POST",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/orders/${id}/status/SHIPPED`,
      requestOptions
    );
  }

  createShipment(id, parcelCount) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      API_BASE_URL +
        `/logistic-service/orders/${id}/create-shipment/${parcelCount}`,
      requestOptions
    );
  }

  deleteShipment(id, shipmentInternalReference) {
    const requestOptions = {
      method: "DELETE",
    };
    return this.httpProxy.fetch(
      API_BASE_URL +
        `/logistic-service/orders/${id}/shipment/${shipmentInternalReference}`,
      requestOptions
    );
  }

  confirmRating(data) {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(data),
    };

    return this.httpProxy.fetch(
      API_BASE_URL +
        `/logistic-service/orders/${data.id}/confirm-rating/${data.shipmentId}`,
      requestOptions
    );
  }

  nextDetail(id) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/orders/${id}/next-detail`,
      requestOptions
    );
  }

  processNext(warehouseId) {
    const requestOptions = {
      method: "GET",
    };
    return this.httpProxy.fetch(
      API_BASE_URL + `/logistic-service/orders/process/${warehouseId}`,
      requestOptions
    );
  }

  exportActivation(data) {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(data),
    };

    return this.httpProxy.fetch(
      `${API_BASE_URL}/logistic-service/orders/export/activation`,
      requestOptions,
      { Accept: "*/*" },
      "blob"
    );
  }

  exportTeamsystem(data) {
    const requestOptions = {
      method: "POST",
      body: JSON.stringify(data),
    };

    return this.httpProxy.fetch(
      `${API_BASE_URL}/logistic-service/orders/export/teamsystem`,
      requestOptions,
      { Accept: "*/*" },
      "blob"
    );
  }
}
